import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../Svg';
const LineIcon = ({ size, ...rest }) => {
    return (_jsx(Svg, { size: size, viewBox: "0 0 24 24", ...rest, children: _jsx("path", { d: "M19.8278 5.00344L5.00344 19.8278C4.77389 20.0574 4.40171 20.0574 4.17216 19.8278C3.94261 19.5983 3.94261 19.2261 4.17216 18.9966L18.9966 4.17216C19.2261 3.94261 19.5983 3.94261 19.8278 4.17216C20.0574 4.40171 20.0574 4.77389 19.8278 5.00344Z", fill: "currentColor" }) }));
};
export default LineIcon;
//# sourceMappingURL=LineIcon.js.map